import { Customer, CustomerFilter } from '../types/customers';
import { User, UserFilter, UserFormData, UserUpdate, ApiResponse } from '../types/users';
import api from './constants';

export interface GetCustomerResponse {
  data: Customer[],
  pagination: {
    page: number;
    total: number;
    totalPages: number;
  }
}

export interface GetUserResponse {
  data: User[],
  pagination: {
    page: number;
    total: number;
    limit: number;
  }
}

export interface GetStatsResponse {
  totalUsers: number;
  totalAdmins: number;
  totalOrders: number;
  totalRevenue: number;
}

export interface GetOrdersStatsResponse {
  scheduled: {
    processing: number;
    completed: number;
    total: number;
  };
  immediate: {
    processing: number;
    completed: number;
    total: number;
  };
  pickup: {
    processing: number;
    completed: number;
    total: number;
  };
  total: {
    processing: number;
    completed: number;
    total: number;
  };
}

const adminApi = {
  getCustomer: async (filter: CustomerFilter = {}): Promise<GetCustomerResponse> => {
    try {
      const response = await api.get<GetCustomerResponse>('/customers', { params: filter });
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },

  getUser: async (filter: UserFilter): Promise<ApiResponse<User[]>> => {
    const response = await api.get('/admin/users', { params: filter });
    return response.data;
  },

  getUserById: async (id: string): Promise<ApiResponse<User>> => {
    const response = await api.get(`/admin/users/${id}`);
    return response.data;
  },

  createUser: async (data: UserFormData): Promise<ApiResponse<User>> => {
    const response = await api.post('/admin/users', data);
    return response.data;
  },

  updateUser: async (data: UserUpdate): Promise<ApiResponse<User>> => {
    const response = await api.patch(`/admin/users/${data.id}`, data);
    return response.data;
  },

  deleteUser: async (id: string): Promise<ApiResponse<User>> => {
    const response = await api.delete(`/admin/users/${id}`);
    return response.data;
  },

  getStats: async (): Promise<GetStatsResponse> => {
    try {
      const response = await api.get<GetStatsResponse>('/manager/dashboard');
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },

  getOrdersStats: async (branch_id?: string): Promise<GetOrdersStatsResponse> => {
    try {
      const response = await api.get<GetOrdersStatsResponse>(branch_id 
        ? `/manager/orders-type-stats?branch_id=${branch_id}` 
        : '/manager/orders-type-stats');
      return response.data
    } catch (error: any) {
      throw error
    }
  },

  createCustomer: async (data: any) => {
    try {
      return await api.post('/customers', data);
    } catch (error: any) {
      console.log('createCustomer error', error)
      throw error;
    }
  },

  updateCustomer: async (id: string, data: any) => {
    try {
      return await api.patch(`/customers/${id}`, data);
    } catch (error: any) {
      console.log('updateCustomer error', error)
      throw error;
    }
  },

  deleteCustomer: async (id: string) => {
    try {
      return await api.delete(`/customers/${id}`);
    } catch (error: any) {
      console.log('deleteCustomer error', error)
      throw error;
    }
  }
};

export default adminApi; 